import { createIcon } from "@chakra-ui/react";

export const ChevronRight = createIcon({
  displayName: "ChevronRight",
  viewBox: "0 0 24 24",
  d: "M17.03 12.113a1.135 1.135 0 0 0 0-1.549l-6.25-6.563a1.009 1.009 0 0 0-1.475 0 1.135 1.135 0 0 0 0 1.549l5.515 5.79-5.512 5.791a1.135 1.135 0 0 0 0 1.549 1.009 1.009 0 0 0 1.475 0l6.251-6.564-.003-.003z",
  defaultProps: {
    "aria-label": "A chevron pointing right"
  }
});

export default ChevronRight;
